export function removeMarkdownTagsAndFormatTables(markdownText) {
  if (!markdownText) return '';
  if (typeof markdownText !== 'string') return markdownText.toString();
  //  Remove all Markdown tags
  let textWithoutFormatting = markdownText.replace(
    /(\*\*|__|_)(.*?)(\*\*|__|_)|~(.*?)~|(\d+\.|-|\*|\+)\s+/g,
    '$2$4',
  );

  // Remove Headers
  textWithoutFormatting = textWithoutFormatting.replace(/#{1,6}/g, '');
  // Remove Number list
  textWithoutFormatting = textWithoutFormatting.replace(/\d{+}.\s/g, '');
  // Remove Blockquote
  textWithoutFormatting = textWithoutFormatting.replace(/(\s>\s)/g, '');
  textWithoutFormatting = textWithoutFormatting.replace(/(^>\s)/g, '');

  // Format table content
  textWithoutFormatting = textWithoutFormatting.replace(
    /<table.*?>|<\/table>/g,
    '',
  );
  // Format headers
  textWithoutFormatting = textWithoutFormatting.replace(/<h.*?>|<\/h>/g, '');
  // Format code
  //   textWithoutFormatting = textWithoutFormatting.replace(
  //     /(```)(^```)(```)/g,
  //     '$2'
  //   );
  // Remove the tbody tags
  textWithoutFormatting = textWithoutFormatting.replace(
    /<tbody.*?>|<\/tbody>/g,
    '',
  );
  textWithoutFormatting = textWithoutFormatting.replace(/<br>/g, '');
  textWithoutFormatting = textWithoutFormatting.replace(
    /<tr.*?>(.*?)<\/tr>/g,
    (match, content) => {
      content = content.replace(/<td.*?>(.*?)<\/td>/g, '$1 ');
      content = content.replace(/<b.*?>(.*?)<\/b>/g, '$1 ');
      return content + '<br />';
    },
  );

  return textWithoutFormatting;
}
